import { render, staticRenderFns } from "./OtrosDocumentos.vue?vue&type=template&id=624f8ad4&scoped=true"
import script from "./OtrosDocumentos.vue?vue&type=script&lang=js"
export * from "./OtrosDocumentos.vue?vue&type=script&lang=js"
import style0 from "./OtrosDocumentos.vue?vue&type=style&index=0&id=624f8ad4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624f8ad4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624f8ad4')) {
      api.createRecord('624f8ad4', component.options)
    } else {
      api.reload('624f8ad4', component.options)
    }
    module.hot.accept("./OtrosDocumentos.vue?vue&type=template&id=624f8ad4&scoped=true", function () {
      api.rerender('624f8ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/otros-documentos/OtrosDocumentos.vue"
export default component.exports